import { render, staticRenderFns } from "./submergAnalysis.vue?vue&type=template&id=4d86650e&scoped=true"
import script from "./submergAnalysis.vue?vue&type=script&lang=js"
export * from "./submergAnalysis.vue?vue&type=script&lang=js"
import style0 from "./submergAnalysis.vue?vue&type=style&index=0&id=4d86650e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86650e",
  null
  
)

export default component.exports